<template>
  <div class="gis-container">
    <div class="lamp-search">
      <div :class="searchShow?'search-text search-show':'search-text'">
        <el-select
          class="search-select"
          v-model="selectedLamp"
          placeholder="请输入设备名称"
          filterable
          clearable
          @change="selectChange"
        >
          <el-option
            v-for="lamp in markers"
            :key="lamp.lamp_id"
            :label="lamp.name"
            :value="{value:lamp.lamp_id, longitude:lamp.longitude, latitude:lamp.latitude}"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search-btn" @click="searchShow=!searchShow"><i class="el-icon-search"></i></div>
    </div>
    <el-amap
      ref="gmap"
      vid="gmapDemo"
      :center="center"
      :zoom="zoom"
      class="gmap-box"
      :mapStyle="'amap://styles/'+modeStyle"
    >
      <template v-for="(marker, index) in markers">
        <el-amap-marker
          v-if="marker && !isNaN(marker.longitude) && !isNaN(marker.latitude) && marker.longitude !== null && marker.latitude !== null"
          :key="index"
          :position="[Number(marker.longitude), Number(marker.latitude)]"
          :icon="
            require('../../assets/home_images/new_point' + marker.ste + '.png')
          "
          :offset="[-12, -32]"
          :events="{ click: () => markerClick(marker) }"
          :vid="index"
          :title="marker.name"
        >
        </el-amap-marker>
      </template>
      <el-amap-info-window
        :position="currentWindow.position"
        :visible="currentWindow.visible"
        :events="{ close: () => close() }"
        closeWhenClickMap="true"
      >
        <div>
          <h3 class="info-title" :title="lampInfo.name">{{ lampInfo.name }}</h3>
          <div class="info-content">
            <div class="line">设备识别号: {{ lampInfo.number }}</div>
            <div class="line">路灯类型: {{ lampInfo.is_double?'双灯':'单灯' }}</div>
            <div class="line">路灯亮度: {{ lampInfo.brightness }}</div>
            <div class="line">所属分组: {{ lampInfo.group_name }}</div>
            <div class="line">当前策略: 
              <template v-if="lampInfo.ms==0">
                <span v-if="lampInfo.group_stg_id">{{ lampInfo.group_stg_name }}(分组策略)</span>
                <span v-else-if="lampInfo.stg_id">{{ lampInfo.stg_name }}(本灯策略)</span>
                <span v-else>暂无策略</span>
              </template>
              <template v-else>
                <span>手动操作</span>
              </template>
            </div>
            <div class="line">在线状态: 
              <span :class="lampInfo.ste?'green':'red'">{{ lampInfo.ste?'在线':'离线' }}</span>
            </div>
            <div class="line">开关状态: 
              <span :class="lampInfo.lights_status?'yellow':'grey'">{{ lampInfo.lights_status?'亮灯':'关灯中' }}</span>
            </div>
          </div>
          <div class="info-controls">
            <div class="botton-one" @click="backLightList(lampInfo.lamp_id)">
              <div class="icon">
                <svg-icon name="lamp-control"/>
              </div>
              <div class="text">路灯控制</div>
            </div>
            <div v-if="lampInfo.camera_list&&lampInfo.camera_list.length" class="botton-one" @click="videoPreview(lampInfo.camera_list[0])">
              <div class="icon">
                <svg-icon name="video-preview"/>
              </div>
              <div class="text">摄像头</div>
            </div>
          </div>
        </div>
      </el-amap-info-window>
    </el-amap>
    <!-- 查看监控 -->
    <div
      class="box_control_bg"
      v-if="videoData.dialogVisible"
      @click="closeVideo"
    ></div>
    <div class="box_control" v-if="videoData.dialogVisible">
      <div class="box_head">
        <span class="box_title">查看设备监控</span>
        <div class="box_close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <div class="video-left">
          <video-box
            ref="video_home_box"
            :video="videoData"
          ></video-box>
        </div>
        <div class="video-right">
          <video-control
            ref="video_home_control"
            :video="videoData"
          ></video-control>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
import lightListApi from "@/api/light/lightList";
import cameraApi from "@/api/light/camera";
import videoControl from "@/components/video/VideoControl";
import videoBox from '@/components/video/VideoBox.vue'
import store from "@/store";
export default {
  name: "Amap",
  components: {
    videoBox,
    videoControl
  },
  data() {
    return {
      selectedLamp: "",
      searchShow: 0,
      zoom: 15,
      modeStyle: 'light',
      center: store.state.user.account.center,
      markers: [],
      currentWindow: {
        position: store.state.user.account.center,
        visible: false,
      },
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: "",
        ms: "",
        sb: [],
        camera_list: [],
      },
      pageInfo: {
        page: 1,
        pageSize: 10000,
      },
      videoData: {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      }
    };
  },
  mounted() {
    // mapstyle start
    let theme = this.$store.state.user.theme
    console.log('theme', theme)
    if(theme=='polarNightBlue'){
      this.modeStyle = 'darkblue'
    }else{
      this.modeStyle = 'light'
    }
    this.$eventBus.$on("mapStyle", (val) => {
      if(this.modeStyle!==val){
        this.modeStyle = val
      }
    })
    // mapstyle over
    this.getLampList();
  },
  beforeDestroy() {
    this.$eventBus.$off("mapStyle")
  },
  methods: {
    getLampList() {
      lightListApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          if(this.$store.state.user.is_supper){
            this.zoom=8
          }
          this.markers = resData.list;
        }
      });
    },
    selectChange(params) {
      const { value, longitude, latitude } = params
      if (value) {
        //根据Id获取设备信息
        lightListApi.lightInfo(value).then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data;
            resData.longitude = longitude
            resData.latitude = latitude
            this.markerClick(resData);
          }
        });
      }
    },
    markerIcon(ste) {
      let icon = ''
      let theme = this.$store.state.user.theme
      if(theme=='moonLightWhite'){
        if(ste){
          icon = require("../../assets/images/light_online.png")
        }else{
          icon = require("../../assets/images/light_line.png")
        }
      }else{
        if(ste){
          icon = require("../../assets/images/darkblue_online.png")
        }else{
          icon = require("../../assets/images/darkblue_line.png")
        }
      }
      return icon
    },

    markerClick(marker) {
      this.center = [Number(marker.longitude), Number(marker.latitude)];
      this.zoom = 15;
      this.lampInfo = marker;
      this.currentWindow.position = [Number(marker.longitude), Number(marker.latitude)];
      this.currentWindow.visible = true;
    },
    close() {
      this.currentWindow.visible = false;
      this.videoData.dialogVisible = false;
    },
    videoPreview(video) {
      if (!this.video.number) {
        return
      }
      cameraApi.cameraInfo({
        number: video.number,
        channel: video.channel
      }).then((res) => {
        if (res.data.code === 1000) {
          this.videoData = {
            id: res.data.data.id,
            title: res.data.data.title,
            number: res.data.data.number,
            camera_type: res.data.data.camera_type,
            channel: res.data.data.channel,
            access_token: res.data.data.access_token,
            dialogVisible: true
          }
        }
      });
    },
    closeVideo() {
      this.videoData = {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      }
    },
    videoGetAccessToken() {
      lightListApi.getAccessToken().then((res) => {
        this.accessToken = res.data.accessToken;
      });
    },
    getGasValue(items) {
      let gas_data = [
        "北风",
        "东北风",
        "东风",
        "东南风",
        "南风",
        "西南风",
        "西风",
        "西北风",
      ];
      let itemValue = "";
      for (let i in items) {
        if (items[i].sb_tye == 8) {
          itemValue +=
            items[i].name + "：" + gas_data[items[i].value] + "<br/>";
        } else {
          itemValue += items[i].name + "：" + items[i].value + "<br/>";
        }
      }
      return itemValue;
    },
    backLightList(){
      this.$router.push({
        name: 'lightList',
        path:"/light/lightList"
      })
    }
  }
};
</script>

<style lang='less'>
.gis-container {
  width:100%;
  height:100%;
  position: relative;
  .lamp-search {
    position: absolute;
    top: 38px;
    right: 50px;
    z-index: 999;
    width:350px;
    .search-text{
      width:300px;
      overflow: hidden;
      padding:10px;
      box-sizing: border-box;
      .search-select{
        opacity: 0;
        height:50px;
        transform: translateX(100%);
        transition: all 0.5s;
        display: block;
        .el-input__inner {
          min-width:100px;
          height:50px;
          border-radius: 50px;
          font-size: 16px;
          padding-left: 20px;
          border: none;
          box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
          &::placeholder,&::-webkit-input-placeholder {
            color: #333;
          }
          &:hover,&:focus {
            border-color: transparent;
          }
        }

        .el-icon-caret-top {
          display: none !important;
        }
      }
      &.search-show{
        .search-select{
          opacity: 1;
          transform: translateX(0);
          transition: all 0.5s;
        }
      }
    }
    .search-btn{
      position: absolute;
      right:0;
      top:10px;
      z-index: 22;
      background-color: #2d8cf0;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      width:50px;
      height:50px;
      font-size: 28px;
      border-radius: 50%;
      cursor: pointer;
      box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
    }
  }

  
  .gmap-box {
    height: 100%;
    width: 100%;
    position: relative;
    min-height: 700px;
  }
  h3.info-title {
    margin: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color:#111 !important;
  }
  .info-content {
    margin: 5px 0;
    overflow: hidden;
  }
  .info-content .line {
    margin: 5px 0;
    line-height: 1.3;
    span{
      display: inline-block;
    }
  }
  .info-controls {
    padding:5px 10px 10px;
    display: flex;
    align-items: center;
    .botton-one{
      margin-right: 20px;
      cursor: pointer;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .icon{
        border: 1px solid rgba(51, 153, 204, 0.5);
        border-radius: 50%;
        width: 50px;
        height: 50px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        background-color: #e9e9ed;
        color:#222;
      }
      .text{
        padding: 5px 0;
        font-size: 14px;
        text-align: center;
        color:#222;
      }
      &:hover{
        .icon{
          color:#000;
          background-color: #e9e9ed;
        }
        .text{
          color:#000;
        }
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
}
.video-left{
  width:600px;
  height:400px;
  float: left;
}
.video-right{
  float: right;
}
</style>
